import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ckUpdatePack, ceTogglePack, packEntrepreneurChoosePack } from '../../../../redux/actions/checkout_operations';
import {
  lpPattern,
  P_SELECT_PACK_1,
  P_SELECT_PACK_2
} from "../../../../tracking/pattern_detector";
import FaqNew from './FAQ';
import Phoneline from './Phoneline';
import Details from './Details';
import Header from './Header';
import { getGlobalData } from '../../../../constants/newCheckoutInfo';
import lpApp from '../../../../app/lp_app';
import ExtraPack from './ExtraPack/ExtraPack';
import PackEntrepreneurAB from '../../upsell/pack-entrepreneurAB';
import { packEntrepreneurData } from '../../upsell/pack-entrepreneurAB-Data'
import './styles.css';
import lpevents from '../../../../tracking/lpevents';
class PackSelector extends Component {
  constructor(props) {
    super(props)
    this.state = {
      hasThreePack: false
    }
  }

  componentDidMount() {
    const { first_price, second_price, third_price, first_fee } = this.props
    const { packHeaderDetails } = getGlobalData({ first_price, second_price, third_price }, first_fee)[lpApp.contractMetaId]
    const appBody = document.getElementById('ce_v3');
    const appContainer = document.getElementById('app-container');
    if (appBody) {
      appBody.classList.add('app-bg-blue')
    }
    if (appContainer) {
      appContainer.classList.add('container-full-width')
      this.setState({ hasThreePack: packHeaderDetails[2] && Object.keys(packHeaderDetails[2]).length ? true : false }, () => { 
        if (this.state.hasThreePack) { 
          appContainer.classList.add('container-threePacks') 
        } 
      })
    }
  }

  componentWillUnmount() {
    const appContainer = document.getElementById('app-container');
    const appBody = document.getElementById('ce_v3');
    if (appBody) {
      appBody.classList.remove('app-bg-blue')
    }
    if (appContainer) {
      appContainer.classList.remove('container-full-width', 'container-threePacks');
    }
  }

  goToNextStep = (id, packName) => {
    //only for specefic product
    if (Object.keys(packEntrepreneurData).indexOf((lpApp.contractMetaId).toString()) > -1) {
      this.props.onPackEntrepreneurChoosePack(id)
      lpevents.trackDatalayerMixpanel('Pack Choice', `${packName}`)
    } else {
      this.onSelectPack(id, packName)
    }
  }

  onSelectPack = (id, packName) => {
    const { selectPack, togglePack } = this.props;
    selectPack(id);
    togglePack(true, id)
    lpevents.trackDatalayerMixpanel('Pack Choice', `${packName}`)
  }

  render() {
    const { first_price, second_price, third_price, first_fee, packEntrepreneurPack } = this.props
    const { headerTitle, packHeaderDetails, contentInfoDetails, faq, extraPacksBottom, extraPacksEC } = getGlobalData({ first_price, second_price, third_price }, first_fee)[lpApp.contractMetaId]
    if (typeof this.props.packEntrepreneurPack !== 'undefined') { return <PackEntrepreneurAB selectPack={this.onSelectPack} index={packEntrepreneurPack} /> }
    const hasThreePack = this.state.hasThreePack
    return (
      <div className={`packSelect-wrapper ${hasThreePack ? 'threePacks' : ''}`}>
        <Header title={headerTitle} />
        {
          extraPacksEC && extraPacksEC.length && extraPacksEC.map(pack => pack && <ExtraPack hasThreePack={hasThreePack} pack={pack} selectPack={this.onSelectPack} isBottom={false} key={pack.id} />)
        }
        {packHeaderDetails && (
          <Details
            hasThreePack={hasThreePack}
            goToNextStep={this.goToNextStep}
            packHeaderDetails={packHeaderDetails}
            packFeatures={contentInfoDetails}
          />
        )}
        {
          extraPacksBottom && extraPacksBottom.length && extraPacksBottom.map(pack => pack && <ExtraPack pack={pack} selectPack={() => this.onSelectPack(pack.id, pack.title)} isBottom={true} key={pack.id} />)
        }
        <FaqNew questions={faq} />
        <Phoneline />
        <p className='footer-copyright'>2020 &copy; LegalPlace SAS</p>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  first_price: state.checkout_operations.prices.first_price,
  second_price: state.checkout_operations.prices.second_price,
  third_price: state.checkout_operations.prices.third_price,
  first_fee: (typeof (state.checkout_operations.admin_fees) !== 'undefined') ? state.checkout_operations.admin_fees.first_price : 0,
  chosen_pack: state.checkout_operations.pack,
  packEntrepreneurPack: state.checkout_operations.packEntrepreneur.choosePack,
  pricing_loading: state.loading_details.pricing,
  promo_percentage: state.checkout_operations.promo_percentage,
  title: state.contract.name,
});

const mapDispatchToProps = dispatch => ({
  togglePack: (val, id) => {
    dispatch(ceTogglePack(val, id));
  },
  onPackEntrepreneurChoosePack: (val) => {
    dispatch(packEntrepreneurChoosePack(val));
  },
  selectPack: (x) => {
    dispatch(ckUpdatePack(x));
    lpPattern.trackInPayment(x + 1);
  }
});

export default connect(mapStateToProps,
  mapDispatchToProps)(PackSelector)



// WEBPACK FOOTER //
// ./src/components/buy/table-checkouts/PackSelectorPage/index.js